<p-dialog header="Ký điện tử không thành công" [(visible)]="pluginNotFound" [style]="{width: '580px'}"
          [resizable]="false">
  <div class="p-grid">
    <div class="p-col-2 p-text-center">
      <img src="/assets/images/usb-not-connected-icon.png" alt="">
    </div>
    <div class="p-col-10">
      <p><b>Hãy kiểm tra các trường hợp dưới đây để khắc phục vấn đề của bạn</b></p>
      <p><b>1.</b> Bạn chưa cài đặt phần mềm ký điện tử hoặc bản cài của bạn cần cập nhật</p>
      <p class="p-pl-4">Hãy cài đặt phần mềm ký điện tử để tiếp tục.</p>
      <p class="p-pl-4"><a target="_blank" rel="noopener noreferrer" href="/assets/tools/HomeCastaSetup.zip"><i
        class="pi pi-download"></i> Tải bộ cài</a></p>

      <p><b>2.</b> Bạn đã cài đặt công cụ <b>Ký số điện tử</b></p>
      <p class="p-pl-4">Hãy mở công cụ <b>Ký số điện tử</b> trước khi ký điện tử</p>
      <p class="p-pl-4"><a style="color: red" href="homeCastaToken:123"><i class="pi pi-info-circle"></i> Mở phần mềm ký điện tử</a></p>
    </div>
  </div>
  <p-footer>
    <p-button label="{{ 'Close'|translate }}" styleClass="p-button-raised p-button-text p-button-plain"
              (onClick)="pluginNotFound=false"></p-button>
  </p-footer>
</p-dialog>

<p-dialog header="Chọn hình thức ký" [(visible)]="isTypeSelectionVisible" [style]="{width: '550px'}"
          styleClass="no-scroll" [resizable]="false" (onHide)="cancel()">
  <div class="p-fluid p-formgrid p-grid">
    <div class="p-field p-col-12">
      <p-dropdown id="type" [options]="signingTypes" optionValue="value" optionLabel="label"
                  (onChange)="typeSelect($event)"></p-dropdown>
    </div>
  </div>
  <p-footer>
    <p-button label="{{ 'Xác nhận'|translate }}" styleClass="p-button-raised" (onClick)="submit()"
              [disabled]="submitting"></p-button>
    <p-button label="{{ 'Close'|translate }}" styleClass="p-button-raised p-button-text p-button-plain"
              (onClick)="cancel()"></p-button>
  </p-footer>
</p-dialog>

<p-dialog header="Chọn CTS" [(visible)]="isCtsSelectionVisible" [style]="{width: '550px'}" styleClass="no-scroll"
          [resizable]="false" (onHide)="cancel()">
  <div class="p-fluid p-formgrid p-grid">
    <div class="p-field p-col-12">
      <label for="type2">{{ 'CTS'|translate }}<span class="required">*</span></label>
      <p-dropdown id="type2" [(ngModel)]="selectedCTS" optionLabel="label" optionValue="value" [options]="items"
                  (onChange)="onCTSChange($event.value)"></p-dropdown>
    </div>
    <div class="p-field p-col-12" *ngIf="displayPinCode">
      <form [formGroup]="form">
        <label for="pinCode">{{ 'Mã PIN'|translate }}<span class="required">*</span></label>
        <input pInputText type="text" id="pinCode" formControlName="pinCode">
      </form>
    </div>
  </div>
  <p-footer>
    <p-button label="Ký xác thực" styleClass="p-button-raised" (onClick)="submit2()" [disabled]="submitting"></p-button>
    <p-button label="{{ 'Close'|translate }}" styleClass="p-button-raised p-button-text p-button-plain"
              (onClick)="cancel()"></p-button>
  </p-footer>
</p-dialog>

<p-dialog [(visible)]="isRemoteWaitVisible" [closable]="false"
          [style]="{width: '413px', height:'230px', boxShadow:' 8px rgba(0, 0, 0, 0.2)', borderRadius:'10px'}"
          styleClass="no-scroll" [resizable]="false">
  <div [style]="{textAlign:'center'}">
    <div class="spinner"></div>
    <div class="message">
      <span>Đã gửi yêu cầu ký.</span>
      <br>
      Vui lòng thực hiện ký xác thực trên ứng dụng ký số
    </div>
    <div class="countdown" id="countdown">
      <b>{{ minutes < 10 ? '0' + minutes : minutes }}:{{ seconds < 10 ? '0' + seconds : seconds }}</b>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="isSigningProcessVisible" [modal]="true" [closable]="false"
          [style]="{width: '500px', height:'200px'}" styleClass="no-scroll" [resizable]="false">
  <div [style]="{textAlign:'center'}">
    <div class="spinner"></div>
    <div class="message2">
      <b>Đang ký xác thực...</b>
    </div>
  </div>
</p-dialog>
